<template>
  <div style="padding-top: 150px">
      <vue-loading type="bars" color="#08A681" :size="{ width: '60px', height: '60px' }"></vue-loading>    
      <p class="loading">请稍等，数据正在加载中...</p>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'
export default {
  created() {
    this.$fetch.post({
      url: '/shop?method=get_all_shop_list',
    }).then(data => {
      let shopList = data.shop_list
      if (
        shopList.ls_new_cashier_shop_list.length ||
        shopList.old_ls_shop_list.length ||
        shopList.wsc_shop_list.length ||
        shopList.pf_shop_list.length ||
        shopList.producer_shop_list.length ||
        shopList.ph_station_list.length ||
        shopList.pps_shop_list.length
      ) {
        this.$router.replace("main/shopList")
      } else {
        this.$router.replace("main/shopRegister")
      }
    }).catch(e => {
      this.openMessage(0, e.error_text || '获取店铺信息失败')
    })
  },

  methods: {
  },

  components: {
    VueLoading
  }
}
</script>

<style lang="scss" scoped>
.loading {
  margin-top: 10px;
  text-align: center;
}
</style>